import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GuideDocLayout from "@/pages/search/GuideDocLayout";
import { fetchGuide, fetchGuides } from "@/lib/searchContent";
import { guideNeighbors } from "@/pages/search/KnowledgeChrome";

export default function GuideDetailPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [neighbors, setNeighbors] = useState({ prev: null, next: null });
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    fetchGuide(slug)
      .then(setData)
      .catch(() => {
        setData(null);
        setError("가이드를 찾을 수 없습니다.");
      });
    fetchGuides()
      .then((res) => setNeighbors(guideNeighbors(res.items || [], slug)))
      .catch(() => setNeighbors({ prev: null, next: null }));
  }, [slug]);

  if (error) {
    return (
      <GuideDocLayout
        testId="guide-missing"
        item={{ title: error, answer: "다른 가이드를 확인해 주세요." }}
        related={[{ href: "/guides", label: "가이드 목록" }]}
      />
    );
  }
  if (!data?.item) {
    return (
      <GuideDocLayout testId="guide-loading" item={{ title: "불러오는 중", summary: "" }} />
    );
  }
  return (
    <GuideDocLayout
      testId="guide-detail"
      item={data.item}
      related={data.related}
      neighbors={neighbors}
    />
  );
}
